module.exports = __webpack_public_path__ + "img/spinner.9d8ed89a.svg";